import React from "react"

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

export default class BackButton extends React.Component {

    state = {
        keyWasDown: false
    }

    componentWillMount() {
        if(this.props.noEsc === undefined) {
            window.addEventListener("keydown", this.onKeyDown, true);
        }
    }

    onKeyDown = (event) => {
        if (!event.path || event.path.length == 0) return;
        if(event.path[0].type !== undefined) {
            this.state.keyWasDown = true
        }
        if(event.keyCode === 27) {
            this.parentFunction()
        }
    }

    parentFunction = () => {
        if(this.props.history !== undefined && this.props.history.length > 2) {
            this.props.history.goBack();
            return
        }
        if(this.props.go !== undefined) {
            this.props.go()
            return
        }
        this.props.history.push(this.props.href)
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.onKeyDown, true);
    }

    render() {
        return (
            <IconButton onClick={this.parentFunction} aria-label="Back">
                <ArrowBackIcon />
            </IconButton>
        )

    }

}



// WEBPACK FOOTER //
// ./src/Components/BackButton.js